<template>
  <Tag>
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </Tag>
</template>

<script setup lang="ts">
import type { TagEmits, TagProps } from "primevue";

import { Tag } from "primevue";

defineProps</* @vue-ignore */ TagProps>();
defineEmits</* @vue-ignore */ TagEmits>();
</script>

<style lang="postcss">
.p-tag {
  @apply inline-flex items-center justify-center rounded-md bg-primary-100 px-2 py-1 text-sm font-bold text-primary-700 gap-1;

  &-icon {
    @apply h-3 w-3 text-xs;
  }

  &-rounded {
    @apply rounded-2xl;
  }

  &-success {
    @apply bg-green-100 text-green-700;
  }

  &-info {
    @apply bg-blue-100 text-blue-700;
  }

  &-warn {
    @apply bg-orange-100 text-orange-700;
  }

  &-danger {
    @apply bg-red-100 text-red-700;
  }

  &-secondary {
    @apply bg-surface-100 text-surface-600;
  }
}
</style>
